import { Box, styled, Typography } from '@mui/material';

import { getPctgColor } from '»utils/pctgColors';

export const MainWrapper = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'isCardMobileDetails' &&
    prop !== 'isCardMobileFundsDetails' &&
    prop !== 'variationPctg',
})(({
  theme,
  isCardMobileDetails,
  isCardMobileFundsDetails,
  variationPctg,
}) => {
  const getMinHeight = () => {
    if (isCardMobileFundsDetails) return '145px';

    if (isCardMobileDetails) return '253px';

    return '148px';
  };

  return {
    width: '344px',
    minHeight: getMinHeight(),
    border: `solid 1px ${theme.palette.colors.borderLine}`,
    backgroundColor: theme.palette.colors.secondaryBackground,
    padding: isCardMobileDetails ? '10px 16px 10px 20px' : '8px 12px 12px',
    borderRadius: '8px',
    marginBottom: 4,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    position: 'relative',
    '&::before': {
      display: isCardMobileDetails ? 'block' : 'none',
      content: `''`,
      position: 'absolute',
      backgroundColor: getPctgColor(variationPctg, theme),
      width: '8px',
      height: '100%',
      bottom: 0,
      left: 0,
      borderTopLeftRadius: '5px',
      borderBottomLeftRadius: '5px',
    },
    [theme.breakpoints.up('md')]: {
      width: '603px',
      padding: isCardMobileDetails ? '8px 24px 8px 32px' : '8px 16px 11px',
      height: isCardMobileDetails && 'auto',
      minHeight: isCardMobileDetails && '158px',
    },
  };
});

export const InnerWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'fullWidth',
})(({ fullWidth }) => ({
  width: fullWidth && '100%',
}));

export const QuotationStyled = styled(Typography)(({ theme }) => ({
  fontSize: '18px',
  fontWeight: 'bold',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  [theme.breakpoints.up('md')]: {
    fontSize: '22px',
  },
}));

export const TimeStyled = styled(Typography)(({ theme }) => ({
  fontSize: '10px',
  fontWeight: 500,
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  lineHeight: 1.8,
}));

export const PropStyled = styled(Typography)(({ theme }) => ({
  fontSize: '10px',
  fontWeight: 500,
  color: theme.palette.colors.lower,
  marginLeft: 0,
  '& span': {
    color: theme.palette.colors.onSecondaryAndDetailBackground,
    marginLeft: '4px',
    [theme.breakpoints.up('md')]: {
      fontSize: '12px',
      marginLeft: '8px',
    },
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '12px',
    marginLeft: '24px',
  },
}));

export const SmallerInfo = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));

export const BottomDetails = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isCardMobileDetails',
})(({ theme, isCardMobileDetails }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: isCardMobileDetails ? 'center' : 'flex-end',
  justifyContent: 'space-between',
  [theme.breakpoints.down('md')]: {
    flexDirection: isCardMobileDetails && 'column',
    alignItems: isCardMobileDetails && 'flex-start',
    justifyContent: isCardMobileDetails && 'unset',
  },
}));

export const QuoteLabelStyled = styled(Typography)(({ theme }) => ({
  fontSize: '10px',
  fontWeight: 500,
  color: theme.palette.colors.label,
  textTransform: 'uppercase',
  marginTop: '14px',
}));

export const LabelStyled = styled(Typography)(({ theme }) => ({
  fontSize: '10px',
  fontWeight: 500,
  color: theme.palette.colors.label,
  textTransform: 'uppercase',
  marginRight: '16px',
  '&:nth-child(2)': {
    marginTop: '8px',
  },
  [theme.breakpoints.up('md')]: {
    marginRight: 0,
  },
}));

export const ValueStyled = styled(Typography)(({ theme }) => ({
  fontSize: '10px',
  fontWeight: 500,
  color: theme.palette.colors.onSecondaryAndDetailBackground,
}));

export const WrapperData = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'show',
})(({ theme, show }) => ({
  display: show ? 'flex' : 'none',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginTop: '12px',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'column',
    marginTop: '14px',
    marginLeft: '30px',
  },
}));

export const InlineWrappedData = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
}));
